module.exports = __webpack_public_path__ + "img/back01.32b3c362.png";